/* @refresh reload */
import { render } from 'solid-js/web';
import { App } from '~/app/App';
import '~/shared/styles/index.css';
import { installStaleChunkReload } from '@sportpark/shared/stale-chunk';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Root element #root not found');
}

installStaleChunkReload(window);

render(() => <App />, root);
